var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOffline)?_c('div',{staticStyle:{"position":"relative"}},[_c('span',{staticStyle:{"right":"0","position":"absolute"}},[_c('v-icon',[_vm._v("mdi-wifi-off")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }